import axios from "axios";
import { config } from "../../config/appConfig";
import { globalApiHandler } from "../../services/services";

export const PRODUCTS = {
  list: {
    start: "PRODUCT_LIST_START",
    success: "PRODUCT_LIST_SUCCESS",
    error: "PRODUCT_LIST_ERROR"
  },
  add: {
    success: "PRODUCT_ADD_SUCCESS"
  },
  delete: {
    success: "PRODUCT_DELETE_SUCCESS"
  },
  subscribe: {
    start: "PRODUCT_SUBSCRIBE_START",
    success: "PRODUCT_SUBSCRIBE_SUCCESS",
    error: "PRODUCT_SUBSCRIBE_ERROR"
  }
};

export const getProductList = () => {
  let url = `${config.BASE_URL}/ntrac/product/productList`;
  return function(dispatch) {
    dispatch({ type: PRODUCTS.list.start, data: "" });
    axios
      .get(url, {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: PRODUCTS.list.success, data });
      })
      .catch(error => {
        const data = error;
        console.log(data);
        dispatch({ type: PRODUCTS.list.error, data });
      });
  };
};

export const placeOrderAction = requestData => {
  let url = `${config.BASE_URL}/ntrac/makePayment/subscribe`;
  return function(dispatch) {
    dispatch({ type: PRODUCTS.subscribe.start, data: "" });
    axios
      .post(url, requestData)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: PRODUCTS.subscribe.success, data });
      })
      .catch(error => {
        const data = error.response.data.message;
        console.log(error.response);
        dispatch({ type: PRODUCTS.subscribe.error, data });
      });
  };
};

export const productPurchseAction = requestData => {
  let url = `/ntrac/makePayment/purchase`;
  return function(dispatch) {
    dispatch({ type: PRODUCTS.subscribe.start, data: "" });
    globalApiHandler(url, "post", requestData)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: PRODUCTS.subscribe.success, data });
      })
      .catch(error => {
        const data = error.data.message;
        console.log(error.data);
        dispatch({ type: PRODUCTS.subscribe.error, data });
      });
  };
};

export const addItem = productId => {
  return function(dispatch) {
    dispatch({ type: PRODUCTS.add.success, productId });
  };
};

export const deleteItem = productId => {
  return function(dispatch) {
    dispatch({ type: PRODUCTS.delete.success, productId });
  };
};



// WEBPACK FOOTER //
// ./src/modules/products/action.js